import React from "react";

/**
 * Выбор юрлица/склада из КОРОТКОГО списка раздела — нативный select.
 *
 * На ТСД системный список крупнее и надёжнее самодельного. Невыбранное после
 * попытки отправить — красная рамка и текст, ЧЕГО не хватает: погашенная
 * кнопка без объяснения читалась как «ничего не происходит». Общий для
 * инвентаризации и перемещения, чтобы подсветка не разъехалась.
 */
export function RefSelect({
  label,
  value,
  onChange,
  options,
  invalid,
  missingText,
  children,
}: {
  label: string;
  value: string;
  onChange: (ref: string) => void;
  options?: { ref: string; name: string }[];
  invalid: boolean;
  /** Текст под полем при `invalid`; пусто — причину называет `children`. */
  missingText: string;
  children?: React.ReactNode;
}): React.ReactElement {
  const id = React.useId();
  return (
    <div className="space-y-1">
      <label htmlFor={id} className="block text-xs font-medium text-muted-foreground">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={invalid}
        className={
          "h-12 w-full rounded-md border bg-background px-3 text-base " +
          (invalid ? "border-2 border-red-600" : "border-input")
        }
      >
        <option value="">— выберите —</option>
        {options?.map((o) => (
          <option key={o.ref} value={o.ref}>
            {o.name}
          </option>
        ))}
      </select>
      {invalid && missingText && <p className="text-sm font-medium text-red-600">{missingText}</p>}
      {children}
    </div>
  );
}
